import React from 'react';
import { Navigate } from 'react-router-dom';

function Trilogia() {
  return <Navigate to="/todos" replace />;
}

export default Trilogia;
